import React from 'react'

const Manual_setup_stripe_usa_mex = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Set Up Stripe USA / Mex - Payment Method
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Configura el método de pago Stripe para tiendas ubicadas en Estados Unidos o México.
        </p>
        <iframe
          src="https://scribehow.com/embed/Set_Up_Stripe_USA__Mex__Payment_Method__KVoscn32SN-HbqjemKf9xg?as=scrollable"
          className="scribe-iframe-general-114"
          width="100%"
          height="3700"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_setup_stripe_usa_mex
